import React, { useContext, useEffect, useState } from 'react'
import { debounce } from 'lodash'
import './Login.css'
import { useHistory } from 'react-router-dom'
import CheckBox from '@/product/components/atoms/CheckBox'
import { Link } from 'react-router-dom'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { LOGO, SITE_NAME } from '@/utils/UI'
import { mapData, handleRedirectInternal } from '@/product/common/components'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import AuthContext from '@/product/context/auth/authContext'
import AlertContext from '@/product/context/alert/alertContext'
import Loaders from '@/product/components/molecules/Loaders'
import SettingContext from '@/product/context/setting/settingContext'
import { Divider } from '@mui/material'
import CustomDialog from '@/product/components/organisms/Dialog'
import TwofactorContext from '@/product/context/twoFactor/twofactorContext'

const Login = (props) => {
    const history = useHistory()
    const authContext = useContext(AuthContext)
    const settingcontext = useContext(SettingContext)
    const alertContext = useContext(AlertContext)
    const twofactorContext = useContext(TwofactorContext)
    const [isLoading, setIsLoading] = useState(true)
    const [showOtp, setshowOtp] = useState(false)
    const [updated, setUpdated] = useState(false)
    const [adminData, setAdminData] = useState({})

    const { setAlert } = alertContext

    const {
        login,
        responseStatus,
        clearResponse,
        isAuthenticated,
        loadUser,
        get2faDetails,
        twoFactor_details,
    } = authContext

    const {
        get2faRequest,
        request_data,
        verify2fa,
        revoke2fa,
        responseStatus: responseStatusFactor,
        clearResponse: clearResponseFactor,
    } = twofactorContext

    const urlParams = new URLSearchParams(window.location.search)

    useEffect(() => {
        setIsLoading(false)
        if (isAuthenticated) {
            handleRedirectInternal(history, 'dashboard')
        }
    }, [isAuthenticated])

    const validationArray = Yup.object({
        email: Yup.string().email('Invalid email format').required('Required!'),
        password: Yup.string()
            .min(8, 'Minimum 8 characters')
            .required('Required!'),
    })

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: '',
            password: '',
            otp: '',
        },
        validationSchema: validationArray,
        onSubmit: (values) => {
            setIsLoading(true)
            setUpdated(true)
            login(values)
        },
    })

    useEffect(() => {
        if (
            urlParams.get('autologin') === 'seller' &&
            props.autoSellerLogin &&
            props.email &&
            props.password
        ) {
            login({ email: props.email, password: props.password })
        }
    }, [urlParams.get('autologin')])

    const loginInfo = [
        {
            label: 'Email address',
            name: 'email',
            type: 'email',
            placeholder: 'Enter your email address',
            class: 'col-12',
            autoFocus: true,
            formik: formik,
            enableAutofillCheck: props?.enableAutofillCheck,
        },
        {
            label: 'Password',
            name: 'password',
            type: 'password',
            placeholder: 'Enter your password',
            class: 'col-12',
            formik: formik,
            enableAutofillCheck: props?.enableAutofillCheck,
        },
    ]

    const debouncedSetAlert = debounce((message, type) => {
        setAlert(message, type)
    }, 2000)

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'login') {
                if (responseStatus.status === 'success') {
                    if (responseStatus.type == 3) {
                        handleRedirectInternal(history, 'dashboard')
                    } else {
                        get2faDetails({
                            email: formik.values.email,
                        })
                    }
                } else {
                    debouncedSetAlert(
                        responseStatus.message,
                        responseStatus.status
                    )
                }
            } else if (responseStatus.from === '2faDetails') {
                if (responseStatus.status === 'error') {
                    debouncedSetAlert(
                        responseStatus.message,
                        responseStatus.status
                    )
                }
            }
            setIsLoading(false)
        }
    }, [responseStatus])

    useEffect(() => {
        if (
            responseStatusFactor &&
            responseStatusFactor.from === 'verifyLogin'
        ) {
            setAlert(responseStatusFactor.message, responseStatusFactor.status)
            if (responseStatusFactor.status !== 'error') {
                formik.values.otp = ''
                handleRedirectInternal(history, 'dashboard')
            }
            setIsLoading(false)
        }
        clearResponseFactor()
    }, [responseStatusFactor])

    useEffect(() => {
        if (twoFactor_details && twoFactor_details.record.length && updated) {
            console.log(
                twoFactor_details.record[0]['2fa_enable'],
                'two factor record'
            )
            let userData = twoFactor_details.record[0]['2fa_enable']
            let userToken = twoFactor_details.record[0]['2fa_token']
                ? twoFactor_details.record[0]['2fa_token']
                : ''
            let userId = twoFactor_details.record[0].id
            console.log(userToken, 'tokkk')
            if (userData) {
                setAdminData(twoFactor_details.record[0])
                setshowOtp(true)
                setIsLoading(false)
            } else {
                handleRedirectInternal(history, 'dashboard')
            }
            clearResponse()
        }
    }, [twoFactor_details])

    const otpData = [
        {
            label: 'Enter OTP',
            name: 'otp',
            type: 'text',
            placeholder: 'Enter your otp',
            class: 'col-12',
            formik: formik,
        },
    ]

    const handleOtp = () => {}

    return (
        <div className="login">
            {isLoading ? (
                <Loaders name="banner" isLoading={isLoading} />
            ) : (
                <>
                    <div className="loginCnt">
                        <form onSubmit={formik.handleSubmit}>
                            <div className="row">
                                <div className="loginLogo">
                                    <img src={LOGO} alt={SITE_NAME} />
                                </div>
                                <div className="col-12 loginTitle">
                                    <h2>Welcome to {SITE_NAME}</h2>
                                </div>
                                <div className="w-100">
                                    {Object.values(mapData(loginInfo))}
                                </div>
                                <div className="fpCnt col-12 d-flex justify-content-between align-items-center mb-2">
                                    <CheckBox label="Remember me" />
                                    {/* <Link to="#">Forgot Password ?</Link> */}
                                </div>
                                <div className="col-12">
                                    <PrimaryButton
                                        id="login_submit"
                                        label="Login"
                                        type="submit"
                                        btnSize="large"
                                    />
                                </div>
                            </div>
                            <div className="loginMiscAction d-flex justify-content-center mt-3 align-items-center">
                                <Link to="/forgot_password">
                                    Forgot password?
                                </Link>
                            </div>
                        </form>
                    </div>
                    <CustomDialog
                        title={'Two Factor Verification'}
                        open={showOtp}
                        className="doubleAuthModal"
                        disableBackdropClick
                    >
                        <h5 className="m-0">Please enter the otp to verify</h5>
                        <div className="actionWrapper">
                            <form
                                onSubmit={formik.handleSubmit}
                                autoComplete="nofill"
                            >
                                <div className="row">
                                    {Object.values(mapData(otpData))}
                                </div>
                                <PrimaryButton
                                    id="bidHistory_submit"
                                    label="Verify"
                                    type="submit"
                                />
                            </form>
                        </div>
                    </CustomDialog>
                </>
            )}
        </div>
    )
}

export default Login
